import React from "react";

const NewQuoteLoadingPage = () => {
  return (
    <div className="h-screen flex justify-center items-center bg-cyan-50">
      <div>
        <h1 className="text-4xl font-bold text-blueGray-800 font-black text-center">
          Nous cherchons les meilleures assurances <br />
          pour votre vélo !
        </h1>
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default NewQuoteLoadingPage;
